import React from 'react'
import ModalConsulta from './ModalConsulta';
import { Tabela } from '../Basicos';

function ModalConsultaChoqueGrupos(props) {
    const { estrutura } = props;
    const { gruposChoque } = estrutura?.modal;

    const columns = React.useMemo(
        () => [{
            Header: "gruposChoque",
            style: {
                display: 'none',
            },
            columns: [
                {
                    Header: 'Semestre',
                    accessor: 'semestre'
                },
                {
                    Header: 'Turma',
                    accessor: 'turma',
                },
                {
                    Header: 'Data',
                    accessor: 'data',
                },
                {
                    Header: 'Grupo',
                    accessor: 'grupo',
                },
                {
                    Header: 'Descrição',
                    accessor: 'descricao',
                },
            ],
        }],
        []
    )

    return (
        <ModalConsulta
            data={props.data}
            modalClass="modal-map"
            modalBodyClass="modalConsulta"
            size="lg"

            {...props}
        >
            <Tabela
                columns={columns}
                data={gruposChoque}
                tabelaClassName="tabelaConsulta"
            />
        </ModalConsulta>
    );
}

export default ModalConsultaChoqueGrupos;
